import { ContextResponseSchema } from "@storytell/types";

export const GetContextResponseSchema = ContextResponseSchema;
